"use client";

import { cn } from "@oreme/ui";
import React, { type ReactElement } from "react";

interface GridProps extends React.ComponentProps<"li"> {
  cols?: number;
}

function Grid({ className, cols = 4 }: GridProps): ReactElement {
  const r = [];
  for (let i = 0; i < cols; i++) {
    r.push(
      <li className={cn("relative w-px bg-border/20", className)} key={i} />,
    );
  }

  return (
    <ul
      className={`absolute top-0 left-0 right-0 bottom-0 grid grid-cols-2 md:grid-cols-${cols} gap-0 place-items-stretch pointer-events-none`}
    >
      {r}
      <li className={cn("absolute w-px top-0 right-0 bottom-0", className)} />
    </ul>
  );
}

export { Grid, type GridProps };
